import React, { useEffect, useState, useRef } from 'react';
import { DateTime } from 'luxon';
import { Dispensary, getReportWithGreenCheckTransactionsAsListOfIdsInsteadOfObjects } from '@gcv/shared';

import { formatDateOrEmpty, formatMoney } from '../../../util/formatHelpers';
import { GcvUserInputContainer } from '../../../lib/GcvUserInputContainer/GcvUserInputContainer';
import { $primary, $blue, $black } from '../../../util/styleVariables';
import { useApi, getEndpoint } from '../../../hooks/';
import { GREEN_CHECK_SERVICES_AMPLIFY_NAME } from 'libs/common-ui/src/lib/common-ui';
import { EnterID } from './styles';

interface DispensaryMap {
  [id: string]: Dispensary;
}

export const account = (name: string) => ({
  name: name,
  selector: 'account',
  sortable: true,
  grow: 1,
});

export const dueDate = (name: string) => ({
  name: name,
  selector: 'dueDate',
  sortable: true,
  grow: 1,
  format: row => {
    if (row.dueDate) {
      return formatDateOrEmpty(row.dueDate);
    }
  },
});

export const dateOfTransaction = (name: string) => ({
  name: name,
  selector: 'dateOfTransaction',
  sortable: true,
  grow: 1,
  format: row => {
    return formatDateOrEmpty(row.dateOfTransaction);
  },
});

export const amount = (name: string) => ({
  name: name,
  selector: 'amount',
  sortable: true,
  grow: 1,
  format: row => {
    return formatMoney(row.amount);
  },
});

export const exportedOn = (name: string) => ({
  name: name,
  selector: 'exportedOn',
  sortable: true,
  grow: 1,
  format: row => formatDateOrEmpty(row.exportedOn),
});

export const sarType = (name: string) => ({
  name: name,
  selector: 'reportType',
  sortable: true,
  grow: 1,
});

export const status = (name, clickHandler) => ({
  name: name,
  selector: 'status',
  sortable: true,
  grow: 1,
  format: row => {
    let color = '';
    let status = '';

    if (row.status === 'open') {
      color = $blue;
      status = 'Start Report';
    } else if (row.status === 'in progress') {
      status = 'Resume';
      color = $primary;
    } else {
      status = 'Completed';
      color = $black;
    }

    const onClick = () => clickHandler(row);
    return (
      <div style={{ color }} onClick={onClick}>
        {status}
      </div>
    );
  },
});

export const bsaIdUpdate = (name: string, openModal) => ({
  name: name,
  selector: 'bsaId',
  sortable: true,
  grow: 1,
  cell: row => {
    return (
      <EnterID
        onClick={() => openModal('update-bsa', row)}
        style={{
          color: !row.bsaId ? $primary : $black,
        }}
      >
        {row.bsaId ? row.bsaId : 'Edit BSA ID'}
      </EnterID>
    );
  },
});

export const trackingId = (name: string, openModal) => ({
  name: name,
  selector: 'trackingId',
  sortable: true,
  grow: 1,
  cell: row => {
    return (
      <EnterID
        onClick={() => openModal('update-tracking', row)}
        style={{
          color: !row.trackingId ? $primary : $black,
        }}
      >
        {row.trackingId ? row.trackingId : 'Edit Tracking ID'}
      </EnterID>
    );
  },
});

export const exportId = (name: string) => ({
  name: name,
  selector: 'id',
  sortable: true,
  grow: 1,
});

export const exportedBy = (name: string) => ({
  name: name,
  selector: 'exported_by',
  sortable: true,
  grow: 1,
});

export const numberOfReports = (name: string) => ({
  name: name,
  selector: 'number_of_reports',
  sortable: true,
  grow: 1,
});

export const bsaIdExport = (name: string, openModal) => ({
  name: name,
  selector: 'bsaId',
  sortable: true,
  grow: 1,
  cell: row => {
    return !row.acknowledgement_file_name ? (
      <EnterID
        onClick={() => openModal('acknowledgement', row)}
        style={{
          color: $primary,
        }}
      >
        Upload Acknowledgement File
      </EnterID>
    ) : (
      row.acknowledgement_file_name
    );
  },
});

export const bsaId = (name: string) => ({
  name: name,
  selector: 'bsaId',
  sortable: true,
  grow: 1,
});
